import { Action, Module, VuexModule } from "vuex-module-decorators";
import { LawType } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class LawTypeModule extends VuexModule {
    @Action
    [LawType.findPageLawType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawType/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawType.listLawType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawType/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawType.saveLawType](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/lawType/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [LawType.deleteLawType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/lawType/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}